// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2YCZc","header":"ReportDetails_header__2bK8N","title":"ReportDetails_title__Pwezq","left":"ReportDetails_left__3kUqp"};